import API from '@/shared/plugins/Api/API'

class TypesV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  async list () {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/capabilities/application`
    })
    return response
  }

  async templates (typeId) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/capabilities/application/${encodeURIComponent(typeId)}/template`
    })
    return response
  }

  async modules (typeId, params = {}) {
    const response = await this.request({
      method: 'get',
      url: `${this.prefix}/capabilities/application/${encodeURIComponent(typeId)}/module`,
      params
    })
    return response
  }
}

export default TypesV3
